module.exports = __webpack_public_path__ + "static/media/megatrix.e450a81a.svg";